export * from '@c4312/blake3-internal';
export * from './hash-fn';
export * from './hash-instance';

export const load = () => Promise.resolve();
